import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '/api';

// Počet nově přiřazených tiketů, které přihlášený uživatel ještě neotevřel (D3).
export function useNovaPrirazeni(aktivni = true) {
  const [pocet, setPocet] = useState(0);
  const obnov = useCallback(() => {
    if (!aktivni) return Promise.resolve();
    return axios.get(`${API}/notifikace/nova-prirazeni`).then(r => setPocet(r.data.pocet || 0)).catch(() => {});
  }, [aktivni]);
  useEffect(() => { obnov(); }, [obnov]);
  return [pocet, obnov];
}

export const odznakStyl = {
  display: 'inline-block', marginLeft: '8px', minWidth: '20px', padding: '1px 7px', borderRadius: '10px',
  background: '#dc2626', color: '#fff', fontSize: '12px', fontWeight: 'bold', lineHeight: '18px', textAlign: 'center',
};
